import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { INLINES } from "@contentful/rich-text-types"
import { Link } from "../Router"
import { convertToInternalUrl, forceTrailingSlash } from "../../util/urlTransforms"

// when we are rendering hyperlinks that are internal we want to use <Link>
// fix render option for inlines.entry_hyperlink
const options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => {

      const url = convertToInternalUrl( node.data.uri )
      
      if( url ) {
        if( url.match( /^(mailto:)|(tel:)/i ) ) { // dont use <Link> for mailto or tel:
          return (
            <a className={ "a-link" }
              href={ url }          
            >
              { children }
            </a>
          )
        } else {
          return (
            <Link className={ "a-link" }
              to={ url }
              onClick={ (e) => {
                if (typeof window !== "undefined" && !e.metaKey && !e.ctrlKey) {
                  window.scrollTo(0, 0);
                }
              }}
            >
              { children }
            </Link>
          )
        }          
      } else {
        return (
          <a href={ node.data.uri } target="_blank" rel="noopener noreferrer nofollow">
            {children}
          </a>
        )
      }
    },
    [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      // if the target is a draft then we will not have target.fields.targetSlug
      // so console.log but return null not to crash the build
      // When in Preview mode it is safe to discard this message 
      if( !node.data.target.fields || !node.data.target.fields.targetSlug ) {
        console.log( "Content with ID: " + node.data.target.sys.id + " does not have a target slug. Probably the content is in draft mode.", node )
        return null
      }

      let slug = forceTrailingSlash( node.data.target.fields.targetSlug )
      let prefix = forceTrailingSlash( node.data.target.fields.targetSlugPrefix )

      const path = prefix[0] == '/' ? prefix + slug : '/' + prefix + slug

      return (
        <Link className={ "a-link" }
          to={ path }
          onClick={ (e) => {
            if (typeof window !== "undefined" && !e.metaKey && !e.ctrlKey) {
              window.scrollTo(0, 0);
            }
          }}
        >
          { children }
        </Link>
      )
    }
  }
}

export default ( richText ) => {  
  return documentToReactComponents( richText, options )
}
